/**
 * Shared money formatting and price-anchor visibility for kit and BYOB.
 * Load before `component-kit.js` and `byob.js` (defer order in Liquid).
 */
(function () {
  function themeFormatMoney(cents) {
    if (cents == null) return '0';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '0';

    const krown = typeof KROWN !== 'undefined' ? KROWN : window.KROWN;
    const format = krown?.settings?.shop_money_format || '{{amount}}';
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return String(cents);

    const fmt = (number, precision, thousands = ',', decimal = '.') => {
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      const centsStr = parts[1] ? decimal + parts[1] : '';
      return dollars + centsStr + (krown?.settings?.iso_code || '');
    };

    let value = '';
    switch (match[1]) {
      case 'amount':
        value = fmt(cents, 2);
        break;
      case 'amount_no_decimals':
        value = fmt(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = fmt(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = fmt(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = fmt(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = fmt(cents, 2, "'");
        break;
      default:
        value = fmt(cents, 2);
    }

    return format.replace(match[0], value).replace('.00', '');
  }

  /** Synchronous viewport check — IntersectionObserver may not run before the first price change. */
  function themePriceAnchorElementVisible(el) {
    if (!el?.getBoundingClientRect) return false;
    const r = el.getBoundingClientRect();
    if (r.width <= 0 && r.height <= 0) return false;
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
  }

  window.kitFormatMoney = themeFormatMoney;
  window.themeFormatMoney = themeFormatMoney;
  window.themePriceAnchorElementVisible = themePriceAnchorElementVisible;
})();
